
export default function authHeader () {
  return { accept: 'application/json' }
}
